import React from 'react'

const EmptyMessage = () => {
    return (
        <div className='d-flex flex-column align-items-center justify-content-center' style={{height: '250px'}}>
            <span className="fa-stack fa-2x">
                <i className="fas fa-envelope fa-stack-1x"></i>
            </span>
            <h6>Aucun message</h6>
        </div>
    )
}

export default EmptyMessage